import dayjs from 'dayjs'
import Guid from './Common/Guid'
import DeviceInfo from './Common/DeviceInfo'
import Util from './Common/Util'
import CryptographyMd5 from './Cryptography/CryptographyMd5'
import CryptographySha1 from './Cryptography/CryptographySha1'
import CryptographyRsa from './Cryptography/CryptographyRsa'
import CryptographyAes from './Cryptography/CryptographyAes'

var ajax = {
    /**
     * @description 3.0系统JS异步请求加解密封装
     * @param {String} options jquery ajax参数
     * @param {String} userToken 3.0用户Token
     * @param {String} systemCode 系统编码
     * @param {String} rsaRemotePublicKey 服务器Pem格式公钥
     */
    threePlatformRequest: function (options, userToken, systemCode, rsaRemotePublicKey) {
        var defaults = {
            type: "POST",
            dataType: "JSON",
            processData: false
        };

        var settings = $.extend({}, defaults, options);

        // 【01】对请求头进行Rsa加密
        var ajaxLocation = Util.getUrlLocation(settings.url);
        var reqHeader = {
            Token: userToken,
            Host: ajaxLocation.Host,
            ApiMethod: ajaxLocation.method.replace(/\//g, "."),
            TimeStamp: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"),
            SecretKey: Guid.newGuid().replace(/-/g, ""),
            Sign: "",
            ClientSysInfo: {
                SysName: DeviceInfo.os.version,
                SysVer: DeviceInfo.os.digits,
                DeviceName: DeviceInfo.browser.browser,
                DeviceMaker: "",
                DeviceVer: DeviceInfo.browser.version,
                DeviceNumber: "",
            },
            SystemCode: systemCode,
        }

        console.log("未加密前的ReqHeader：" + JSON.stringify(reqHeader));

        var strTimeStamp = dayjs(reqHeader.TimeStamp).add(20, 's').format("YYYYMMDDHHmmssSSS");
        var aesKey = CryptographyMd5.encryptToHex(reqHeader.SecretKey + strTimeStamp);

        settings.beforeSend = function (xhr, setting) {
            if (typeof (options.beforeSend) === "function") {
                options.beforeSend(xhr, setting);
            }

            var baseReq = {
                ReqId: Guid.newGuid(),
                OperatorName: "123",
                Param: JSON.parse(JSON.stringify(setting.data))
            };

            console.warn("请求前未加密参数：" + JSON.stringify(baseReq));
            console.warn("请求前加密开始时间：" + new Date().getTime());
            // 【01】请求头数据签名
            reqHeader.Sign = CryptographySha1.encryptStrToHex(JSON.stringify(baseReq));

            // 【02】设置请求头 REQ_HEADER_LPX_TOOLS
            var reqHeaderEncryptBase64 = CryptographyRsa.encryptToBase64(JSON.stringify(reqHeader), rsaRemotePublicKey);
            xhr.setRequestHeader("REQ_HEADER_LPX_TOOLS", reqHeaderEncryptBase64);

            // 【03】请求体加密
            var reqBodyEncrypt = CryptographyAes.encryptToBase64(JSON.stringify(baseReq), aesKey);

            setting.data = JSON.stringify({
                Value: reqBodyEncrypt
            });
            console.warn("请求前加密结束时间：" + new Date().getTime());
        };
        settings.dataFilter = function (data, type) {
            if (data) {
                var dataJson = JSON.parse(data);
                if (dataJson && dataJson.Value) {
                    console.warn("请求完成解密开始时间：" + new Date().getTime());
                    dataJson = JSON.parse(CryptographyAes.decryptFormBase64(dataJson.Value, aesKey));
                    console.warn("请求完成解密结束时间：" + new Date().getTime());
                    console.warn("请求完成已解密返回值：" + JSON.stringify(dataJson));
                }
                if (typeof (options.dataFilter) === "function") {
                    options.dataFilter(dataJson, type);
                }
                return JSON.stringify(dataJson);
            }
        }

        $.ajax(settings);
    }
}

export default ajax;